import { isEmpty, keys } from 'lodash';
import * as topojson from 'topojson-client';

import * as layerOps from '../api/Layers/layer-operations';

import adaptURL from './adapt-url';
import joinGeoJSONThematicLayer from './join-geojson-thematic-layers';
import loadGeoJSONFromURL from './load-geojson-from-url';
import methodPromise from './method-promise-wrapper';
import parseGeoJSONTable from './parse-geojson-table';

/**
 * Fetches the geojson and returns the two arrays needed for the table.
 *
 * @async
 * @param {string} layer - The GeoJSON layer.
 * @returns {object} An object containing the two arrays needed for the table.
 * @throws {Error} If something goes wrong.
 */
const loadGeoJSONTable = async layer => {
  let tableTitle = [];
  let tableBody = [];
  let coordinates = [];
  let type = [];
  let geojson = '';
  let topojsonFile = '';
  let objectKey = '';
  try {
    const url = adaptURL(layerOps.getURL(layer));
    switch (true) {
      case layerOps.isJoin(layer):
        geojson = await joinGeoJSONThematicLayer({
          geojsonId: layerOps.getGeoJSONId(layer),
          thematicId: layerOps.getThematicId(layer),
          geojsonPropToJoin: layerOps.getGeoJSONPropToJoin(layer),
          thematicKeyToJoin: layerOps.getThematicKeyToJoin(layer),
          sorensenDiceMinimun: layerOps.getSorensenDiceMinimun(layer),
          layerSubType: layerOps.getSubType(layer)
        });
        break;
      case layerOps.isOGR(layer) && !isEmpty(url):
        geojson = await methodPromise('layers.loadOGRGeoJSON', {
          url: adaptURL(layerOps.getURL(layer)),
          layerName: layerOps.getOGRLayerName(layer),
          attribute: layerOps.getOGRAttributes(layer).split(',')
        });
        break;
      case layerOps.isTopoJSON(layer) && !isEmpty(url):
        topojsonFile = await loadGeoJSONFromURL(url);
        [objectKey] = keys(topojsonFile.objects);
        geojson = topojson.feature(topojsonFile, topojsonFile.objects[objectKey]);
        break;
      case !isEmpty(url):
        geojson = await loadGeoJSONFromURL(url);
        break;
      default:
        break;
    }
    ({ coordinates, tableBody, tableTitle, type } = parseGeoJSONTable(geojson));
    return { coordinates, tableBody, tableTitle, type };
  } catch (err) {
    throw new Error(err.message);
  }
};

export default loadGeoJSONTable;
